import React from 'react';
import { Image, Typography } from 'tfc-components';

import image from 'assets/images/home/whatwedo.png';
import Icon from 'components/atoms/Icon';
import Section from 'components/organisms/Section';

const WhatWeDo: React.FC = () => (
  <Section>
    <div className="p-home_whoWeAre p-home_whoWeAre-reverse">
      <div className="p-home_whatWeDo_image">
        <Image imgSrc={image} alt="Who we are" ratio={592 / 375} />
      </div>
      <div className="p-home_whoWeAre_content">
        <Section.Title left small>
          What We Do
        </Section.Title>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          We don&#39;t do demos.
          <br />
          We don&#39;t build things just because we can.
        </Typography.Text>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          Every product starts from a real user need and is built to scale
        </Typography.Text>
        <Typography.Text extendClasses="p-home_whoWeAre_text">
          <Typography.Text
            extendClasses="f-20x24 p-home_whoWeAre_textBold"
            fontweight="600"
          >
            What makes us different?
          </Typography.Text>
          We combine:
        </Typography.Text>
        <ul className="p-home_whoWeAre_list">
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>
              AI as the core engine (not a buzzword)
            </Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>Rapid product discovery & testing</Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>Traction-first mindset</Typography.Text>
          </li>
          <li>
            <Icon iconName="checkOrange" size="24" />
            <Typography.Text>
              User insights
              {'>'}
              {' '}
              assumptions
            </Typography.Text>
          </li>
        </ul>
      </div>
    </div>
  </Section>
);

export default WhatWeDo;
